import { c as _c } from "react/compiler-runtime";
import { useEffect, useEffectEvent, useRef } from 'react';
import { useWeb3Context } from '@/contexts/Web3Context';
export function useOnWalletChange(onChange) {
  const $ = _c(10);
  const {
    account
  } = useWeb3Context();
  const t0 = account.chain?.id;
  let t1;
  if ($[0] !== account.address || $[1] !== t0) {
    t1 = {
      address: account.address,
      chainId: t0
    };
    $[0] = account.address;
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const openedWith = useRef(t1);
  const onWalletChange = useEffectEvent(onChange);
  const walletChainId = account.chain?.id;
  let t2;
  if ($[3] !== account.address || $[4] !== onWalletChange || $[5] !== walletChainId) {
    t2 = () => {
      const opened = openedWith.current;
      const addressChanged = account.address !== opened.address;
      const chainChanged = walletChainId != null && opened.chainId != null && walletChainId !== opened.chainId;
      if (addressChanged || chainChanged) {
        onWalletChange();
      }
    };
    $[3] = account.address;
    $[4] = onWalletChange;
    $[5] = walletChainId;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== account.address || $[8] !== walletChainId) {
    t3 = [account.address, walletChainId];
    $[7] = account.address;
    $[8] = walletChainId;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  useEffect(t2, t3);
}